import { render, staticRenderFns } from "./Trends.vue?vue&type=template&id=06e49ef2&scoped=true&"
import script from "./Trends.vue?vue&type=script&lang=js&"
export * from "./Trends.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Trends.vue?vue&type=style&index=1&id=06e49ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e49ef2",
  null
  
)

export default component.exports